export default __webpack_public_path__ + "29d22858a9755f9673c75680c724ca5f.svg";